import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, GiftIcon, PickaxeIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { productImage, productShortName, totalBonuses, totalVolumes } from '../data/offer';
const highlights = [{
  icon: BookOpenIcon,
  label: `${totalVolumes} comprehensive volumes`
}, {
  icon: GiftIcon,
  label: `${totalBonuses} exclusive bonuses`
}, {
  icon: ZapIcon,
  label: 'Instant access'
}];
export function Hero() {
  const scrollToPricing = () => document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
  return <section className="relative isolate overflow-hidden bg-navy" data-id="element-119" data-mp="s9zxxe4wz0l5">
      <div className="h-1.5 w-full bg-gold" aria-hidden="true" data-id="element-120" data-mp="ncq2nhuufupe" />

      <div className="mx-auto max-w-5xl px-4 pb-14 pt-12 text-center lg:pb-20 lg:pt-16" data-id="element-121" data-mp="nekn6v27dksy">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="inline-flex items-center gap-2 rounded-full border border-gold/60 bg-steel px-4 py-2 text-xs font-bold uppercase tracking-[.14em] text-mineral" data-id="element-122" data-mp="3czfkfwx3o34z">
          <PickaxeIcon className="h-4 w-4" aria-hidden="true" data-id="element-123" data-mp="39aurjeh4toxr" /> {productShortName}
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.06,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-5 max-w-4xl text-balance text-4xl font-extrabold leading-[1.08] text-white sm:text-5xl lg:text-6xl" data-id="element-124" data-mp="3e8mtl1bhqrfo">
          Master your year of mineral processing education
          <br data-id="element-125" data-mp="2violil7p0yc1" />
          <span className="text-mineral" data-id="element-126" data-mp="2vi54d6pvadz2">in one afternoon.</span>
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.12,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-9 max-w-3xl" data-id="element-127" data-mp="2hjf3dfzxfu5f">
          <img src={productImage} alt="Mineral Processing Teacher Ready: nine volumes and five bonus resources covering fundamentals, comminution, classification, gravity and magnetic separation, flotation, dewatering, plant operations, safety and sustainability, and teaching" className="mx-auto w-full drop-shadow-2xl" data-id="element-128" data-mp="s3mfk97g6b1j" />
        </motion.div>

        <div className="mt-9" data-id="element-129" data-mp="1azkqxecanulv">
          <Button onClick={scrollToPricing} arrow className="w-full sm:w-auto" data-id="element-130" data-mp="1ayjilhmnxm7u">
            Get your teacher ready now
          </Button>
        </div>

        <ul className="mt-7 flex flex-wrap justify-center gap-2 text-xs font-bold text-white" data-id="element-131" data-mp="111oln361ftvo">
          {highlights.map(({
          icon: Icon,
          label
        }) => <li key={label} className="inline-flex items-center gap-1.5 rounded-lg border border-gold/40 bg-steel px-3 py-2" data-id="element-132" data-mp="x3h62bnb8ym2">
              <Icon className="h-3.5 w-3.5 text-mineral" aria-hidden="true" data-id="element-133" data-mp="3hpsglavsi14o" />
              {label}
            </li>)}
        </ul>

        <p className="mt-6 text-xs font-semibold uppercase tracking-[.14em] text-muted" data-id="element-134" data-mp="21amwtbz2vwne">
          Created by mineral processing education specialists, for educators worldwide · Updated 2026
        </p>
      </div>
    </section>;
}